import { useSyncExternalStore } from 'react';

// Lets UI outside Perci's provider open Perci — today the Support window, which lives in
// the main header, above every page. Perci only exists on some pages (a patient's page, the
// Templates tab, the activity editor), so the launcher is registered by PlanChatWidget while
// it is mounted, and is null everywhere else. Callers use that null to hide their
// "Ask Perci" button rather than offering one that cannot work.

type Launcher = () => void;

let launcher: Launcher | null = null;
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((listener) => listener());
}

/** Register Perci's open action. Returns the matching unregister. */
export function registerPerciLauncher(open: Launcher): () => void {
  launcher = open;
  emit();
  return () => {
    // Only clear our own registration: on a page change the next widget can mount
    // before the previous one unmounts.
    if (launcher === open) {
      launcher = null;
      emit();
    }
  };
}

export function getPerciLauncher(): Launcher | null {
  return launcher;
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Perci's open action while a page with Perci is on screen, otherwise null. */
export function usePerciLauncher(): Launcher | null {
  return useSyncExternalStore(subscribe, getPerciLauncher, getPerciLauncher);
}
